import * as ACTIONS from './actions';

function _updateAddress(addresses, payload) {
  const newAddresses = addresses.map(address => {
    return address.id === payload.addresses.id ? payload.addresses : address
  })

  return newAddresses
}

function _deleteAddress(addresses, payload) {
  const newAddresses = []

  addresses.map(address => {
    return address.id !== payload.id ? newAddresses.push(address) : null
  })

  return newAddresses
}

export default function reducer(
  state = {
    health: false,
    authorized: false,
    user: null,
    token: null,
    device_token: null,
    appReady: false,
    tabActive: 1,
    fcm_token: null,
    env: null,
    client: null,
    availability: true,
    visibleMainToolbar: true,
    visibleSearchView: false,
    visibleCartView: false,
  },
  { type, payload }
) {
  switch (type) {
    case ACTIONS.GET_DATA_SUCCESS:
      return Object.assign({}, state, { splash: payload })

    case ACTIONS.USER_AUTHENTICATED:
      return Object.assign({}, state, {
        authorized: true,
        user: payload.user,
        token: payload.token
      })

    case ACTIONS.USER_UNAUTHORIZED:
      return Object.assign({}, state, {
        authorized: false,
        user: null
      })

    case ACTIONS.CHANGE_TAB_ACTIVE:
      return Object.assign({}, state, {
        tabActive: payload.tab
      })

    case ACTIONS.GET_PROFILE_ERROR:
      return Object.assign({}, state, {
        token: null,
        authorized: false,
        user: null
      })

    case ACTIONS.GET_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        authorized: true,
        user: payload.customer
      })

    case ACTIONS.REGISTER_SUCCESS:
      return Object.assign({}, state, {
        // authorized: true,
      })

    case ACTIONS.VERIFICATION_SUCCESS:
      return Object.assign({}, state, {
        // authorized: true,
        user: payload.customer
      })

    case ACTIONS.REGISTRATION_COMPLETE:
      return Object.assign({}, state, {
        authorized: true
      })

    case ACTIONS.GET_ADDRESSES_SUCCESS:
      return Object.assign({}, state, {
        user: Object.assign({}, state.user, {
          addresses: payload.addresses
        })
      })

    case ACTIONS.POST_ADDRESSES_SUCCESS:
      return Object.assign({}, state, {
        user: Object.assign({}, state.user, {
          addresses: state.user.addresses ? [payload.addresses, ...state.user.addresses] : [payload.addresses]
        })
      })

    case ACTIONS.PUT_ADDRESSES_SUCCESS:
      return Object.assign({}, state, {
        user: Object.assign({}, state.user, {
          addresses: _updateAddress(state.user.addresses, payload)
        })
      })

    case ACTIONS.DELETE_ADDRESSES_SUCCESS:
      return Object.assign({}, state, {
        user: Object.assign({}, state.user, {
          addresses: _deleteAddress(state.user.addresses, payload)
        })
      })

    case ACTIONS.GET_DEVICE_TOKEN_SUCCESS:
      return Object.assign({}, state, {
        device_token: payload.device_token
      })

    case ACTIONS.GET_DEVICE_TOKEN_ERROR:
      return Object.assign({}, state, {
        device_token: null
      })

    case ACTIONS.DISABLE_APP_TRUE:
      return Object.assign({}, state, {
        appReady: false
      })

    case ACTIONS.ENABLE_APP_TRUE:
      return Object.assign({}, state, {
        appReady: true
      })

    case ACTIONS.HEALTH_INFO_OK:
      return Object.assign({}, state, {
        health: true
      })

    case ACTIONS.HEALTH_INFO_ERROR:
      return Object.assign({}, state, {
        health: false
      })

    case ACTIONS.GET_PUSH_NOTIFICATION_TOKEN_SUCCESS:
      return Object.assign({}, state, {
        fcm_token: payload.token
      })

    case ACTIONS.GET_CONFIG_SUCCESS:
      return Object.assign({}, state, {
        env: payload.env
      })

    case ACTIONS.GET_CLIENT_INFO_SUCCESS:
      return Object.assign({}, state, {
        client: payload.client
      })

    case ACTIONS.GET_EDIT_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        user: payload.customer
      })

    case ACTIONS.CHANGE_AVAILABILITY:
      return Object.assign({}, state, {
        availability: payload.value
      })

    case ACTIONS.VISIBLE_MAIN_TOOLBAR:
      return Object.assign({}, state, {
        visibleMainToolbar: payload.visible
      })

    case ACTIONS.VISIBLE_SEARCH_VIEW:
      return Object.assign({}, state, {
        visibleSearchView: payload.visible
      })

    case ACTIONS.VISIBLE_CART_VIEW:
      return Object.assign({}, state, {
        visibleCartView: payload.visible
      })

    default:
      return state
  }
}
